/**
 * 用户登陆相关
 */
import api from '@/api'

let future = {}


future.getIndustries = async function (formData) {
    // console.log("future.getLongShort===",formData);
    return api.get(`/futures/industries`, formData)
}

future.getLongShort = async function (formData) {
    // console.log("future.getLongShort===",formData);
    return api.get(`/futures/longShort`, formData)
}

future.getStrategy = async function (formData) {
    // console.log("future.getLongShort===",formData);
    return api.get(`/futures/getStrategy`, formData)
}

future.getSignal = async function (formData) {
    // console.log("future.getLongShort===",formData);
    return api.get(`/futures/getSignal`, formData)
}

future.getProfitDaily = async function (formData) {
    return api.get(`/futures/getProfitDaily`, formData)
}




export default future
